import { Component, HostListener, Input, OnInit } from '@angular/core';
import { EMemberStatus } from '@fp/enums/member-status.enum';
import { EMemberType } from '@fp/enums/member-type.enum';
import { Member } from '@fp/models/member.model';
import { CommonService } from '@fp/services/common.service';
import { DatadogService } from '@fp/services/datadog.service';
import { AppConfigService, ReferralConfig } from '@fp/services/app-config.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'referral-card',
  templateUrl: './referral-card.component.html',
  styleUrls: ['./referral-card.component.css'],
})
export class ReferralCardComponent implements OnInit {
  includedEmployers: string[] = []; // Will be populated from the FPFrontendApp application in AppConfig
  member: Member;
  isIncludedEmployer: boolean;
  isPrimaryMember: boolean;
  isNewMember: boolean;
  @Input() fromPage: string;

  constructor(
    private commonService: CommonService,
    private datadogService: DatadogService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    this.member = this.commonService.getMember();

    // Fetch referral program employers from AppConfig
    this.appConfigService.getConfig()
      .pipe(finalize(() => this.memberStatus()))
      .subscribe({
        next: (config: ReferralConfig) => this.includedEmployers = Object.keys(config)
      });
  }

  private memberStatus(): void {
    this.isIncludedEmployer = this.includedEmployers.includes(this.member?.Employer.Code);
    this.isPrimaryMember = this.member?.MemberTypeId === EMemberType.Primary;
    this.isNewMember = this.member?.MemberStatus.MemberStatusId === EMemberStatus.New;
  }

  handleReferralCodeClick() {
    this.datadogService.addAction('referral_code_link_clicked', {
      fromPage: this.fromPage,
    });
  }

  // Need to know if member is new and a primary member also if they belong to one of the included employers
  // If so, show the referral card
  public get showReferralCard(): boolean {
    return this.isIncludedEmployer && this.isPrimaryMember && this.isNewMember;
  }
}
